import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { loadMenuTalents } from "../utils/Network";
import { BuildTalents, getDefaultName, isAdmin, getUser, isEditor } from "../utils";
import { getCmsMainNavSection } from "../utils/cmsMainNavConfig";
import TalentBadge from "./TalentBadge";

export default function Mainmenu() {
  const location = useLocation();
  const nav = {
    talents: getCmsMainNavSection("talents"),
    contests: getCmsMainNavSection("contests"),
    users: getCmsMainNavSection("users"),
    posts: getCmsMainNavSection("posts"),
    settings: getCmsMainNavSection("settings"),
  };
  const isSettingRoute =
    location.pathname.includes("/setting") ||
    location.pathname.includes("/about") ||
    location.pathname.includes("/notification") ||
    location.pathname.includes("/language") ||
    location.pathname.includes("/country") ||
    location.pathname.includes("/faq") ||
    location.pathname.includes("/videogallerylist") ||
    location.pathname.includes("/popupmessage") ||
    location.pathname.includes("/banned") ||
    location.pathname.includes("/testimonial") ||
    location.pathname.includes("/pages");

  const [current_user, setCurrentUser] = useState(null);

  const [menu_talents, setMenuTalents] = useState(null);

  useEffect(() => {
    setCurrentUser(getUser());
    if (isAdmin() || isEditor()) {
      loadMenuTalents().then((talents) => {
        var parents = BuildTalents(talents, 1);
        setMenuTalents(parents);
      });
    }

  }, []);

  return (
    <>
      <aside className="main-sidebar">
        <section className="sidebar">
          <div className="cms-sidebar-toggle-wrap">
            <a
              href="#toggle"
              className="sidebar-toggle cms-sidebar-toggle-btn"
              data-toggle="push-menu"
              role="button"
              aria-label="Toggle navigation"
            >
              <span className="cms-sidebar-toggle-bar"></span>
              <span className="cms-sidebar-toggle-bar"></span>
              <span className="cms-sidebar-toggle-bar"></span>
            </a>
          </div>

          <ul className="sidebar-menu" data-widget="tree">
           
            {(isAdmin() || isEditor()) && (
              <>
                <li
                  className={`treeview sidebar-menu-talents ${location.pathname.includes("/talent") ||
                      location.pathname.includes("usertalent")
                      ? "active open"
                      : ""
                    } `}
                >
                  <a href={nav.talents.to}>
                    <i className="fa fa-star"></i>
                    <span>{nav.talents.label}</span>
                    <span className="pull-right-container">
                      <i className="fa fa-angle-left pull-right"></i>
                    </span>
                  </a>
                  <ul className="treeview-menu">
                    {menu_talents &&
                      menu_talents.map((item) => (
                        <li
                          className={
                            item.childs && item.childs.length > 0
                              ? "treeview"
                              : undefined
                          }
                          key={item.id + "menu"}
                        >
                          <a
                            href={`/cms/talent/${item.id}`}
                            className={`${location.pathname === "/course" ? "active" : ""
                              } `}
                          >
                            <i className="fa fa-music"></i>
                            <span>{getDefaultName(item.names)}</span>
                            {item.childs && item.childs.length === 0 && (
                              <TalentBadge count={item.count_of_usertalents} talent_id={item.id} />
                            )}
                            {item.childs && item.childs.length > 0 && (
                              <span className="pull-right-container">
                                <i className="fa fa-angle-left pull-right"></i>
                              </span>
                            )}
                          </a>
                          {item.childs && (
                            <ul className="treeview-menu">
                              {item.childs.map((child) => (
                                <React.Fragment key={`menu-child-${child.id}`}>
                                  <li>
                                    <a href={`/cms/talent/${child.id}`}>
                                      <i className="fa fa-circle-o"></i>
                                      {getDefaultName(child.names)}

                                      <TalentBadge count={child.count_of_usertalents} talent_id={child.id} />
                                    </a>
                                  </li>

                                  {child.childs.map((agrand_child) => (
                                    <li
                                      key={`menu-grandchild-${agrand_child.id}`}
                                      style={{ marginLeft: 15 }}
                                    >
                                      <a href={`/cms/talent/${agrand_child.id}`}>
                                        <i className="fa fa-circle"></i>
                                        {getDefaultName(agrand_child.names)}

                                        <TalentBadge
                                          talent_id={agrand_child.id}
                                          count={agrand_child.count_of_usertalents} 
                                        />
                                      </a>
                                    </li>
                                  ))}
                                </React.Fragment>
                              ))}
                            </ul>
                          )}
                        </li>
                      ))}
                    {(isAdmin()) && (
                      <>
                        <li>
                          <a
                            href={nav.talents.to}
                            className={`${location.pathname === "/courses" ? "active" : ""
                              } `}
                          >
                            <i className="fa fa-plus"></i>
                            Manage
                          </a>
                        </li>
                      </>
                    )}
                  </ul>
                </li>

                <li
                  className={`treeview ${location.pathname.includes("/Contest") ||
                      location.pathname.includes("/poll") ||
                      location.pathname.includes("/videogalleries")
                      ? "active open"
                      : ""
                    } `}
                >
                  <a href={nav.contests.to}>
                    <i className="fa fa-flag-o"></i>
                    <span>{nav.contests.label}</span>
                    <span className="pull-right-container">
                      <i className="fa fa-angle-left pull-right"></i>
                    </span>
                  </a>
                  <ul className="treeview-menu">
                    <li>
                      <a
                        href={nav.contests.to}
                        className={`${location.pathname === "/courses" ? "active" : ""
                          } `}
                      >
                        <i className="fa fa-flag-o"></i>
                        {nav.contests.label}
                      </a>
                      {(isAdmin()) && (
                        <a
                          href="/cms/ratings"
                          className={` ${location.pathname.includes("/rating") ? "active " : ""
                            } `}
                        >
                          <i className="fa fa-star"></i> <span>Ratings</span>
                        </a>
                      )}
                      <a
                        href="/cms/coursehistories"
                        className={`${location.pathname === "/post" ? "active" : ""
                          } `}
                      >
                        <i className="fa fa-history"></i>
                        History
                      </a>
                      {(isAdmin()) && (
                        <a
                          href="/cms/polls"
                          className={`${location.pathname === "/polls" ? "active" : ""
                            } `}
                        >
                          <i className="fa fa-area-chart"></i>
                          Polls
                        </a>
                      )}
                      {(isAdmin()) && (
                        <a
                          href="/cms/videogalleries"
                          className={` ${location.pathname.includes("/videogalleries") ? "active " : ""
                            } `}
                        >
                          <i className="fa fa-camera"></i> <span>Videos</span>
                        </a>
                      )}
                      
                    </li>
                  </ul>
                </li>

              </>
            )}
            {isAdmin() && (
              <>

                
                <li
                  className={`treeview ${location.pathname.includes("/user/") ||
                      location.pathname.includes("/users") ||
                      location.pathname.includes("/jur") ||
                      location.pathname.includes("/editor") ||
                      location.pathname.includes("administrator")
                      ? "active open"
                      : ""
                    } `}
                >
                  <a href={nav.users.to}>
                    <i className="fa fa-user"></i>
                    <span>{nav.users.label}</span>
                    <span className="pull-right-container">
                      <i className="fa fa-angle-left pull-right"></i>
                    </span>
                  </a>
                  <ul className="treeview-menu">
                    <li>
                      <a
                        href="/cms/users"
                        className={`${location.pathname === "/users" ? "active" : ""
                          } `}
                      >
                        <i className="fa fa-users"></i>
                        Talents
                      </a>
                      <a
                        href="/cms/juries"
                        className={`${location.pathname === "/juries" ? "active" : ""
                          } `}
                      >
                        <i className="fa fa-gavel"></i>
                        Jury
                      </a>
                      <a
                        href="/cms/audience"
                        className={`${location.pathname === "/audience" ? "active" : ""
                          } `}
                      >
                        <i className="fa fa-users"></i>
                        Audience
                      </a>
                      <a
                        href="/cms/editors/"
                        className={`${location.pathname === "/editors" ? "active" : ""
                          } `}
                      >
                        <i className="fa fa-users"></i>
                        Editors
                      </a>
                      <a
                        href="/cms/administrators/"
                        className={`${location.pathname === "/user" ? "active" : ""
                          } `}
                      >
                        <i className="fa fa-user"></i>
                        Administrators
                      </a>
                    </li>
                  </ul>
                </li>

              </>
            )}
            <li
              className={`treeview ${location.pathname.includes("/post") ||
                  location.pathname.includes("/categor")
                  ? "active open"
                  : ""
                } `}
            >
              <a href={nav.posts.to}>
                <i className="fa fa-edit"></i>
                <span>{nav.posts.label}</span>
                <span className="pull-right-container">
                  <i className="fa fa-angle-left pull-right"></i>
                </span>
              </a>
              <ul className="treeview-menu">
                <li>
                  <a
                    href="/cms/posts"
                    className={`${location.pathname === "/posts" ? "active" : ""
                      } `}
                  >
                    <i className="fa fa-list"></i>
                    All Posts
                  </a>
                  <a href="/cms/categories" className={`${location.pathname === "/cms/categories" ? "active" : "" } `} >
                    <i className="fa fa-folder"></i>
                    Categories
                  </a>
                  <a
                    href="/cms/post"
                    className={`${location.pathname === "/post" ? "active" : ""
                      } `}
                  >
                    <i className="fa fa-plus"></i>
                    Add New
                  </a>
                </li>
              </ul>
            </li>
            {(isAdmin() || isEditor()) && (
              <li className={`${isSettingRoute ? "active" : ""}`}>
                <Link to={nav.settings.to}>
                  <i className="fa fa-cog"></i> <span>{nav.settings.label}</span>
                </Link>
              </li>
            )}
          </ul>
        </section>
      </aside>
    </>
  );
}
